import React, { useState, useEffect } from 'react';
import './subNav.css';
import PropTypes from 'prop-types';
import DisplayContent from '../../modals/displayModal/displayContent';

const SubNav = ({data, sendReset, excelExport, handleModalClick, handleDDSearch, deactivate, access}) => {
  let dataCopy = JSON.parse(JSON.stringify(data))
  const [formattedData, setFormattedData] = useState({});
  const [searchFormFields, setFormFields] = useState({});

  const handleChange = (value, key) => {
    setFormFields((prevFields) => ({
        ...prevFields,
        [key]: value,
    }));
  }

  const handleAction = (action) => {
    if(action == 'Reset') {
      setFormFields({})
      sendReset();
      setFormattedData({});
    }
    else if(action == 'Download') excelExport();
    else if(action == 'Create' || action == 'Revoke') handleModalClick();
    else if(action == 'Apply') handleDDSearch(searchFormFields);
    else if(action == 'Deactivate') deactivate();
  }

  const formatData = () => {
      if(access && !access.grantCreate) {
        dataCopy = data.filter(v=> v.name != 'Create' && v.name != 'Revoke')
      }
      const formatdata = dataCopy.reduce((acc, item) => {
          if(!acc[item.section]) acc[item.section] = [];
          acc[item.section].push(item);
          return acc;
      }, {})
      setFormattedData(formatdata);
  }

  useEffect(()=> {
      if(Object.keys(formattedData).length == 0 && data) formatData();
  }, [formattedData, data]);



  return (
    <>
    <nav>
      <div className='subNavigationContainer'>        
        {
            Object.keys(formattedData).length > 0 && Object.entries(formattedData).map(([key, value]) => (
                <div key={`section`+key} className={key == '1' ? 'leftAlign' : 'rightAlign'}>
                    { value && <DisplayContent contentData={value} source='subNav' handleInputChange={handleChange} handleButtonClick={handleAction}/>}
                </div>
            ))
        }
      </div>
    </nav>
    </>
  );
};
export default SubNav;

SubNav.propTypes = {
  filterDataEvent: PropTypes.func
}
